import { QueryClient, QueryClientConfig, QueryCache, MutationCache } from '@tanstack/react-query';
import { toaster } from '@/components/ui/toaster';

function isResponseError(error: Response | Error): error is Response {
    return error.constructor.name === 'Response';
}

const queryCache = new QueryCache({
    onError: (error: Error | Response) => {
        if (isResponseError(error)) {
            if (error.status === 403) {
                toaster.create({
                    title: 'Not authorised to perform this request',
                    type: 'error',
                    duration: 3000,
                });
            } else if (error.status === 500) {
                toaster.create({
                    title: 'An unknown error occurred, please try again',
                    type: 'error',
                    duration: 3000,
                });
            }
        }
    },
});

const mutationCache = new MutationCache({
    onError: (error: Error | Response) => {
        if (isResponseError(error)) {
            if (error.status === 403) {
                toaster.create({
                    title: 'Not authorised to perform this action.',
                    type: 'error',
                    duration: 5000,
                });
            } else if (error.status === 500) {
                toaster.create({
                    title: 'An unknown error occurred, please try again',
                    type: 'error',
                    duration: 5000,
                });
            }
        }
    },
});

const DEFAULT_QUERY_OPTIONS: QueryClientConfig = {
    queryCache,
    mutationCache,
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: false,
        },
    },
};

export const queryClient = new QueryClient(DEFAULT_QUERY_OPTIONS);
